import { createWebHistory, createRouter } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { updateAppSearchMetadata } from '../seo'

const routes: RouteRecordRaw[] = [
  { path: '/', component: () => import('@/views/ChatView.vue') },
  { path: '/chat', component: () => import('@/views/ChatView.vue') },
  { path: '/practice', component: () => import('@/views/ChatView.vue') },
  { path: '/stats', component: () => import('@/views/ChatView.vue') },
  { path: '/settings', component: () => import('@/views/ChatView.vue') },

  { path: '/drill', component: () => import('@/views/DrillView.vue') },
  { path: '/email', component: () => import('@/views/EmailView.vue') },
  { path: '/password', component: () => import('@/views/PasswordView.vue') },
  { path: '/manage-account', component: () => import('@/views/ManageAccountView.vue') },
  { path: '/no-access', component: () => import('@/views/NoAccess.vue') },
  { path: '/sub-onboarding', component: () => import('@/views/SubOnboardingView.vue') },
  { path: '/login', component: () => import('@/views/LoginView.vue') },
  { path: '/subscribe', component: () => import('@/views/SubscribeView.vue') },
  { path: '/subscribed', component: () => import('@/views/SubOnboardingView.vue') },
  { path: '/pending-subscription', component: () => import('@/views/PendingSubscriptionView.vue') },
  { path: '/cancelled', component: () => import('@/views/CancelledView.vue') },
  { path: '/max-usage', component: () => import('@/views/MaxUsage.vue') },
  { path: '/history', component: () => import('@/views/HistoryView.vue') },
  { path: '/delete-account', component: () => import('@/views/DeleteAccountView.vue') },
  { path: '/account-deleted', component: () => import('@/views/AccountDeletedView.vue') },
  { path: '/reset-password', component: () => import('@/views/ResetPasswordView.vue') },
  { path: '/confirmation-code', component: () => import('@/views/ConfirmationCodeView.vue') },
  { path: '/flashcards', component: () => import('@/views/FlashcardsView.vue') },
  { path: '/session-completed', component: () => import('@/views/SessionCompletedView.vue') },
  { path: '/onboarding', component: () => import('@/views/OnboardingView.vue') },
  { path: '/flashcards-onboarding', component: () => import('@/views/FlashcardsOnboardingView.vue') },
  { path: '/i/:code', component: () => import('@/views/ChatView.vue') },
  { path: '/email-does-not-exist', component: () => import('@/views/EmailDoesNotExistView.vue') },
  { path: '/marketing-feedback', component: () => import('@/views/MarketingFeedbackView.vue') },
  { path: '/marketing-unsubscribe', component: () => import('@/views/MarketingUnsubscribeView.vue') },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? { left: 0, top: 0 }
  }
})

router.afterEach((to) => {
  updateAppSearchMetadata(to.path, to.matched.length > 0)
})

function walkRoutes(routeList: RouteRecordRaw[], visit: (route: RouteRecordRaw) => void): void {
  for (const route of routeList) {
    visit(route)
    if (route.children && route.children.length > 0) {
      walkRoutes(route.children, visit)
    }
  }
}

function prefetchAllRouteComponents(): void {
  walkRoutes(routes, (route) => {
    const loader = route.component as unknown
    if (typeof loader === 'function') {
      void (loader as () => Promise<unknown>)()
    }
  })
}

void router.isReady().then(() => {
  const schedulePrefetch = (): void => prefetchAllRouteComponents()
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(schedulePrefetch)
  } else {
    setTimeout(schedulePrefetch, 0)
  }
})

export default router;
